const blockTypes = {
  "value": {
    title: "Значение",
    description: "Базовый блок ключ-значение"
  },
  "array": {
    title: "Массив",
    description: "Блок с массивом"
  },
  "selectable": {
    title: "Выбор типа",
    description: "Блок с вариантами выбора"
  },
  "constant": {
    title: "Константа",
    description: "Блок с постоянным значением"
  },
  "group": {
    title: "Группировка",
    description: "Объединяет блоки под вкладкой"
  }
}

export default blockTypes